import React from "react";
import clockSvg from "../../../static/images/clock.svg";
import Image from "react-bootstrap/Image";

export default function PendingIcon() {
  return <Image src={clockSvg} />;
}
